import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { GlobalStyles } from "@mui/material";

import LandingPage from './pages/LandingPage';
import UIUXPage from './pages/uiux';
import PostersPage from './pages/PostersPage';
import PhotographyPage from './pages/PhotographyPage';
import ContactPage from './pages/ContactPage';

import { F } from './fonts';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      {/* ── Load Google Fonts & apply globally ── */}
      <GlobalStyles styles={`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Lato:ital,wght@0,300;0,400;0,700;1,400&display=swap');

        *, *::before, *::after {
          box-sizing: border-box;
        }

        body {
          font-family: ${F.body};
          margin: 0;
          padding: 0;
        }

        h1, h2, h3, h4, h5, h6 {
          font-family: ${F.heading};
        }
      `} />

      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/"        element={<LandingPage />} />
          <Route path="/uiux" element={<UIUXPage />} />
          <Route path="/posters"  element={<PostersPage />} />
          <Route path="/photography" element={<PhotographyPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;